import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';

export default class MovieInfo extends lng.Component {
  static _template() {
    return {
      ...super._template(),
      Dollar: {},
      Info: {
        flex: { direction: 'column', justifyContent: 'center' },
        Title: {
          y: 70,
          text: {
            fontSize: 60,
            fontFace: 'OpenSans-SemiBold',
            lineHeight: 68,
            maxLines: 3,
            wordWrapWidth: 600,
            shadow: true,
            shadowColor: Colors('#000000').get(),
            shadowOffsetX: 0,
            shadowOffsetY: 3,
            shadowBlur: 6,
          },
        },
        Informations: {
          y: 55,
          DurationAndIcon: {
            Svg: {
              y: 3,
              w: 25,
              h: 25,
              zIndex: 0,
            },
            text: {
              fontSize: 26,
              maxLines: 1,
              wordWrapWidth: 600,
            },
          },
          Rating: {
            text: {
              fontSize: 26,
              maxLines: 1,
              wordWrapWidth: 600,
              shadow: true,
              shadowColor: Colors('#000000').get(),
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              shadowBlur: 6,
            },
          },
          Votes: {
            y: 7,
            text: {
              fontSize: 18,
              maxLines: 1,
              wordWrapWidth: 600,
              shadow: true,
              shadowColor: Colors('#000000').get(),
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              shadowBlur: 6,
            },
          },
          ContentRating: {
            x: 375,
            text: {
              fontFace: 'OpenSans-Regular',
              fontSize: 26,
              maxLines: 1,
              wordWrapWidth: 600,
              shadow: true,
              shadowColor: Colors('#000000').get(),
              shadowOffsetX: 0,
              shadowOffsetY: 3,
              shadowBlur: 6,
            },
          },
        },
        Category: {
          y: 100,
          text: {
            fontFace: 'OpenSans-Regular',
            fontSize: 24,
            maxLines: 1,
            wordWrapWidth: 600,
            shadow: true,
            shadowColor: Colors('#000000').get(),
            shadowOffsetX: 0,
            shadowOffsetY: 3,
            shadowBlur: 6,
          },
        },
        Description: {
          y: 120,
          h: 200,
          text: {
            fontFace: 'OpenSans-Regular',
            fontSize: 30,
            lineHeight: 40,
            wordWrapWidth: 610,
            maxLines: 5,
            shadow: true,
            shadowColor: Colors('#000000').get(),
            shadowOffsetX: 0,
            shadowOffsetY: 3,
            shadowBlur: 6,
          },
        },
      },
      Cover: {
        x: 600,
        y: 0,
        w: 1200,
        h: 690,
        alpha: 0.9,
        texture: {
          type: lng.textures.ImageTexture,
        },
        shader: { type: lng.shaders.FadeOut, fade: [0, 0, 90, 90] },
      },
    };
  }
}
